// eslint-disable-next-line import/no-anonymous-default-export
export default /* glsl */`
#if defined( RE_IndirectDiffuse )

	#ifdef USE_LIGHTMAP

		vec4 lightMapTexel= texture2D( lightMap, vUv2 );
		//lightMapTexel= vec4(1.0);
		vec3 lightMapIrradiance = lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;

		#ifndef PHYSICALLY_CORRECT_LIGHTS

			lightMapIrradiance *= PI; // factor of PI should not be present; included here to prevent breakage

		#endif

		irradiance += lightMapIrradiance;

	#endif

	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )

		
    if (!noEnvironmentMapping){
		iblIrradiance += getLightProbeIndirectIrradiance( /*lightProbe,*/ geometry, maxMipLevel );
	}

	//irradiance *= magic1;

	#endif

#endif

#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	if (!noEnvironmentMapping){
		radiance += getLightProbeIndirectRadiance( /*specularLightProbe,*/ geometry.viewDir, geometry.normal, material.specularRoughness, maxMipLevel );
		//radiance *= metalness;
		//radiance *= magic1;
		#ifdef CLEARCOAT

			clearcoatRadiance += getLightProbeIndirectRadiance( /*specularLightProbe,*/ geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness, maxMipLevel );

		#endif
	} else {
		radiance += vec3(1.0);
	}
#endif
`;